// Sistema de colores centralizado para toda la aplicación

// COLORES GENERALES - USADOS EN MÚLTIPLES COMPONENTES
export const GENERAL_COLORS = {
  // Colores de fondo más comunes
  BACKGROUND_TABLE_HEADER: "#dfdfdf",
  BACKGROUND_WHITE: "#ffffff",
  BACKGROUND_CARD: "#f8fafc",
  BACKGROUND_ROW_ALTERNATE: "#f8f9fa",
  BACKGROUND_ROW_HOVER: "#839ca5",
  BACKGROUND_NEUTRAL: "#a4bac5",
  
  // Colores de texto más comunes
  TEXT_BRAND: "#465d64",
  TEXT_MUTED: "#9ca3af",
  TEXT_PRIMARY: "#333",
  TEXT_SECONDARY: "#666",
  
  // Colores de bordes más comunes
  BORDER_BRAND: "#465d64",
  BORDER_LIGHT: "#ccc",
  BORDER_TABLE: "#e0e0e0",
  
  // Colores de botones más comunes
  BACKGROUND_BUTTON_PRIMARY: "#174045",
  BACKGROUND_BUTTON_SECONDARY: "#334155",
  
  // Colores de sombras más comunes
  SHADOW_DARK: "#000",
};

// COLORES PRINCIPALES DE LA MARCA
export const BRAND_COLORS = {
  PRIMARY: "#314f5b",
  PRIMARY_DARK: "#1e293b",
  PRIMARY_LIGHT: "#56717c",
  SECONDARY: "#465d64",
  ACCENT: "#174045",
  ACCENT_DARK: "#1565c0",
};

// Colores de estado
export const STATUS_COLORS = {
  SUCCESS: "#28A745",
  SUCCESS_LIGHT: "#98FA98",
  WARNING: "#ffc107",
  ERROR: "#ff0000",
  ERROR_LIGHT: "#fd5656",
  INFO: "#0066CC",
  INFO_LIGHT: "#90caf9",
};

// Colores de fondo
export const BACKGROUND_COLORS = {
  PRIMARY: "#f8fafc",
  SECONDARY: "#f1f5f9",
  TERTIARY: "#fafafa",
  CARD: "#ffffff",
  TABLE_HEADER: "#dfdfdf",
  TABLE_ROW_EVEN: "#ebebee",
  TABLE_ROW_ODD: "#ffffff",
  DARK: "#174045",
  DARK_LIGHT: "#354a53",
  BLUISH_GRAY: "#9bb1bb",
  LIGHT_BLUISH_GRAY: "#c1d1d8",
  PALE_BLUISH_GRAY: "#dee3e5",
};

// Colores de texto
export const TEXT_COLORS = {
  PRIMARY: "#333333",
  SECONDARY: "#666666",
  TERTIARY: "#999999",
  LIGHT: "#ffffff",
  DARK: "#000000",
  MUTED: "#64748b",
  BRAND: "#174045",
};

// Colores de bordes
export const BORDER_COLORS = {
  PRIMARY: "#e2e8f0",
  SECONDARY: "#e5e7eb",
  LIGHT: "#b0bec5",
  MEDIUM: "#ccc",
  DARK: "#314f5b",
  BRAND: "#174045",
  LIGHT_GRAY: "#d0d0d0",
};

// Colores de sombras
export const SHADOW_COLORS = {
  PRIMARY: "#000000",
  BRAND: "#465d64",
};

// Colores específicos de componentes
export const COMPONENT_COLORS = {
  BUTTON: "#68848d",
  BUTTON_HOVER: "#56717c",
  ICON_WEIGHT: "#C0C0C0",
  ICON_TIME: "#0066CC",
  ICON_ALERT: "#ff0000",
  ICON_SUCCESS: "#00bfa5",
  ICON_INFO: "#9c27b0",
};

// Colores de tabla
export const TABLE_COLORS = {
  HEADER: "#465d64",
  ROW_ALTERNATE: "#E8F2EF",
  ROW_TOTAL: "#d8e2df",
  DARK: "#174045",
};

// Colores de Material-UI
export const MUI_COLORS = {
  PRIMARY: "#174045",
  PRIMARY_DARK: "#1565c0",
  SECONDARY: "#9c27b0",
  SUCCESS: "#2e7d32",
  WARNING: "#ed6c02",
  ERROR: "#d32f2f",
  INFO: "#0288d1",
};

// Colores de estado de carga
export const LOADING_COLORS = {
  SPINNER: "#0000ff",
  PROGRESS: "#39ff14",
};

// Colores de validación
export const VALIDATION_COLORS = {
  VALID: "#5cb85c",
  INVALID: "#d9534f",
  NEUTRAL: "#ccc",
};

// Colores específicos de ComponentCalculoCargaDeFabrica
export const CALCULO_CARGA_COLORS = {
  NON_WORKING_DAY: "#B0B0B0",
  PRIMARY_LIGHT: "#56717c",
  MEDIUM_LOAD: "#9bb1bb",
  LOW_LOAD: "#c1d1d8",
  VERY_LOW_LOAD: "#dee3e5",
  MODAL_HEADER: GENERAL_COLORS.BACKGROUND_CARD,
  MODAL_BORDER: "#e2e8f0",
  MODAL_TEXT_PRIMARY: "#1e293b",
  MODAL_TEXT_SECONDARY: "#64748b",
  MODAL_TEXT_TERTIARY: "#334155",
  MODAL_BUTTON: GENERAL_COLORS.BACKGROUND_BUTTON_PRIMARY,
  MODAL_BUTTON_SHADOW: GENERAL_COLORS.BACKGROUND_BUTTON_PRIMARY,
  MODAL_ROW_EVEN: "#ebebee",
  MODAL_ROW_ODD: GENERAL_COLORS.BACKGROUND_WHITE,
};

// Colores específicos de ComponentConsultaPiezasTabla
export const CONSULTA_PIEZAS_COLORS = {
  MO_HAS_PROCESSES: "#b2dfdb",
  SUCCESS_GREEN: "#2E7D32",
  SUCCESS_DARK: "#00695c",
  TEXT_PRIMARY: "#263238",
  TEXT_SECONDARY: "#455a64",
  TEXT_TERTIARY: "#546e7a",
  TEXT_MUTED: GENERAL_COLORS.TEXT_SECONDARY,
  TEXT_LIGHT: "#999",
  TEXT_PLACEHOLDER: "#78909c",
  TEXT_INPUT: "#37474f",
  BORDER_LIGHT: "#b0bec5",
  BORDER_INPUT: "#b0bec5",
  BACKGROUND_CARD: GENERAL_COLORS.BACKGROUND_WHITE,
  BACKGROUND_WHITE: GENERAL_COLORS.BACKGROUND_WHITE,
  BACKGROUND_ROW_TOTAL: "#cfd8dc",
  BACKGROUND_SEARCH: "#e0f2f1",
  BACKGROUND_BUTTON: GENERAL_COLORS.BACKGROUND_BUTTON_PRIMARY,
  BUTTON_EXCEL_PIEZAS: "#4CAF50",
  BUTTON_EXCEL_FORNITURAS: "#9C27B0",
  SHADOW_DARK: GENERAL_COLORS.SHADOW_DARK,
  SHADOW_BRAND: "#546e7a",
  TEXT_DARK: "#174045",
  // Estilos del modal
  modalOverlay: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
  },
  modalContent: {
    maxHeight: "70%",
    minWidth: "60%",
    backgroundColor: "#ffffff",
    borderRadius: 15,
    padding: 20,
    shadowColor: "#000000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.4,
    shadowRadius: 5,
    elevation: 10,
  },
  modalHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 10,
  },
  modalTitle: {
    fontSize: 20,
    fontWeight: "bold",
    color: "#263238",
    textAlign: "center",
    flex: 1,
  },
  modalInput: {
    borderWidth: 1,
    borderColor: "#b0bec5",
    borderRadius: 8,
    padding: 12,
    marginBottom: 15,
    fontSize: 14,
    color: "#263238",
    backgroundColor: "#ffffff",
  },
  modalScrollView: {
    maxHeight: 400,
    marginBottom: 15,
  },
  modalItem: {
    padding: 15,
    marginBottom: 10,
    backgroundColor: "#e0f2f1",
    borderRadius: 8,
    borderWidth: 1,
    borderColor: "#b2dfdb",
  },
  modalItemContent: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  modalItemIndex: {
    fontWeight: "bold",
    color: "#546e7a",
    marginRight: 10,
    fontSize: 14,
  },
  modalItemText: {
    flex: 1,
  },
  modalItemTitle: {
    fontSize: 16,
    fontWeight: 500,
    color: "#263238",
    textAlign: "center",
    marginBottom: 5,
  },
  modalItemSubtitle: {
    fontSize: 12,
    color: "#546e7a",
    textAlign: "center",
  },
  modalNoData: {
    padding: 20,
    alignItems: 'center',
  },
  modalNoDataText: {
    fontSize: 14,
    color: "#546e7a",
    fontStyle: "italic",
  },
  modalFooter: {
    alignItems: 'center',
    paddingTop: 10,
  },
  modalButton: {
    backgroundColor: "#68848d",
    paddingVertical: 12,
    paddingHorizontal: 24,
    borderRadius: 8,
  },
  modalButtonText: {
    color: "#ffffff",
    fontSize: 16,
    fontWeight: "bold",
  },
};

// Colores específicos de componenteQueryDetalleTiempos
export const QUERY_DETALLE_TIEMPOS_COLORS = {
  BACKGROUND_HEADER: "#E8F2EF",
  BACKGROUND_CARD: GENERAL_COLORS.BACKGROUND_WHITE,
  BACKGROUND_ROW: "#fafafa",
  BACKGROUND_ROW_ALTERNATE: "#f0f8ff",
  BACKGROUND_TABLE_HEADER: GENERAL_COLORS.BACKGROUND_TABLE_HEADER,
  BACKGROUND_BUTTON_PRIMARY: "#5c7380",
  BACKGROUND_BUTTON_SECONDARY: GENERAL_COLORS.BORDER_LIGHT,
  BACKGROUND_SUCCESS: "#218838",
  BACKGROUND_ROW_HOVER: "#c0c0c0",
  BACKGROUND_ROW_SELECTED: "#e3f2fd",
  TEXT_PRIMARY: GENERAL_COLORS.TEXT_PRIMARY,
  TEXT_SECONDARY: "#555",
  TEXT_BLACK: "black",
  BORDER_LIGHT: "#f0f0f0",
  BORDER_MEDIUM: GENERAL_COLORS.BORDER_LIGHT,
};

// Colores específicos de AdminSettingScreen
export const ADMIN_SETTING_SCREEN_COLORS = {
  PRIORITY_HIGH: "#ef4444",
  PRIORITY_MEDIUM: "#f59e0b",
  TEXT_MUTED: "#64748b",
  TEXT_SECONDARY: "#94a3b8",
  TEXT_PRIMARY: "#1e293b",
  TEXT_DARK: "#374151",
  TEXT_GRAY: "#4b5563",
  TEXT_LIGHT_GRAY: "#f6f6f6",
  BACKGROUND_WHITE: GENERAL_COLORS.BACKGROUND_WHITE,
  BACKGROUND_LIGHT: "#f8fafc",
  BACKGROUND_CARD: GENERAL_COLORS.BACKGROUND_WHITE,
  BACKGROUND_ERROR: "#fef2f2",
  BORDER_LIGHT: "#e2e8f0",
  BORDER_SECONDARY: "#f1f5f9",
  BORDER_ERROR: "#fecaca",
  SHADOW_DARK: GENERAL_COLORS.SHADOW_DARK,
};

// Colores específicos de ControlDeReparacionesScreen
export const CONTROL_REPARACIONES_SCREEN_COLORS = {
  BACKGROUND_ROW: "#f8f9fa",
  BACKGROUND_ROW_ALTERNATE: GENERAL_COLORS.BACKGROUND_ROW_ALTERNATE,
  BACKGROUND_TABLE_HEADER: GENERAL_COLORS.BACKGROUND_TABLE_HEADER,
  BACKGROUND_BUTTON_PRIMARY: GENERAL_COLORS.BACKGROUND_BUTTON_PRIMARY,
  BACKGROUND_BUTTON_SECONDARY: GENERAL_COLORS.BACKGROUND_BUTTON_SECONDARY,
  BACKGROUND_BUTTON_PURPLE: "#9c27b0",
  BACKGROUND_CARD: "#F9FAFB",
  BACKGROUND_INPUT: "#F3F4F6",
  TEXT_SECONDARY: GENERAL_COLORS.TEXT_SECONDARY,
  TEXT_PRIMARY: "#374151",
  TEXT_BRAND: GENERAL_COLORS.TEXT_BRAND,
  TEXT_MUTED: GENERAL_COLORS.TEXT_MUTED,
  BORDER_LIGHT: "#e5e7eb",
  BORDER_MEDIUM: GENERAL_COLORS.BORDER_TABLE,
  BORDER_SECONDARY: "#f5f5f5",
  BORDER_BRAND: GENERAL_COLORS.BORDER_BRAND,
  BORDER_PURPLE: "#9c27b0",
  BORDER_CARD: "#e5e7eb",
  BORDER_TABLE: "#e5e7eb",
  SHADOW_DARK: GENERAL_COLORS.SHADOW_DARK,
};

// Colores específicos de ComponentFundicionStatus
export const FUNDICION_STATUS_COLORS = {
  STATUS_RETRASO: "#174045",
  STATUS_VERY_HIGH: "#51707d",
  STATUS_HIGH: "#6c8b98",
  STATUS_MEDIUM_HIGH: "#8ca6b2",
  STATUS_MEDIUM: "#adc3cf",
  STATUS_LOW: "#cfdae0",
  STATUS_VERY_LOW: "#e6edef",
  LOADING_PROGRESS: "#39ff14",
  // Colores de tabla unificada
  TABLE_HEADER_PRIMARY: "#465d64",
  TABLE_HEADER_SECONDARY: "#56717c",
  TABLE_BORDER_PRIMARY: "#314f5b",
  TABLE_BORDER_SECONDARY: "#e0e6ed",
  TABLE_BORDER_TOTAL: "#c1d1d8",
  TABLE_BORDER_FINAL: "#bdc3c7",
  TABLE_ROW_EVEN: "#ffffff",
  TABLE_ROW_ODD: "#f5f6fa",
  TABLE_TOTAL_ROW: "#9bb1bb",
  TABLE_TOTAL_BORDER: "#465d64",
  // Colores de botones
  BUTTON_DISABLED_BG: "#ccc",
  BUTTON_DISABLED_TEXT: "#666",
};

// Colores específicos de ComponentEstadoOro
export const ESTADO_ORO_COLORS = {
  // Colores de iconos
  ICON_PRIMARY: "#174045",
  ICON_SECONDARY: "#9c27b0",
  // Colores de tabla
  TABLE_BORDER: "#e0e0e0",
  TABLE_HEADER_BG: "#465d64",
  TABLE_HEADER_TEXT: "white",
  // Colores de ubicación
  LOCATION_ICON: "#465d64",
  LOCATION_TEXT: "#465d64",
  // Colores de chips
  CHIP_GOLD_BG: "#e8f5e8",
  CHIP_GOLD_TEXT: "#465d64",
  CHIP_GOLD_BORDER: "#c8e6c9",
  CHIP_PLATINUM_BG: "#f3e5f5",
  CHIP_PLATINUM_TEXT: "#465d64",
  CHIP_PLATINUM_BORDER: "#e1bee7",
  // Colores de resumen
  SUMMARY_BG: "#f8f9fa",
  SUMMARY_BORDER: "#e9ecef",
  SUMMARY_ICON: "#174045",
  SUMMARY_TEXT: "#174045",
  // Colores de filas de totales
  TOTAL_ROW_BG: "#f5f5f5",
  TOTAL_CELL_BG: "#e0e0e0",
};

// Colores específicos de ComponentControlOro
export const CONTROL_ORO_COLORS = {
  BACKGROUND_SUBTLE: "#90caf9",
  BACKGROUND_DARK: "#537575",
  BACKGROUND_DARKER: "#405c5c",
};

// Colores específicos del calendario de metales
export const METALS_CALENDAR_COLORS = {
  HEADER_BG: "#465d64",
  HEADER_TEXT: "#ffffff",
  NAV_ICON: BRAND_COLORS.ACCENT,
  WEEKDAY_BG: "#f1f5f9",
  WEEKDAY_TEXT: "#475569",
  DAY_BG: "#ffffff",
  DAY_BG_ALT: "#f8fafc",
  DAY_BORDER: "#e2e8f0",
  TODAY_BORDER: BRAND_COLORS.ACCENT,
  STOCK_TEXT: "#2e7d32", // verde
  NEED_TEXT: "#d32f2f",  // rojo
  AVAILABLE_POS_TEXT: "#2e7d32",
  AVAILABLE_NEG_TEXT: "#d32f2f",
  TOOLTIP_BG: "#111827",
  TOOLTIP_TEXT: "#f9fafb",
  // Colores de fondo para disponibilidad
  DAY_BG_POSITIVE: "#e8f5e8", // verde claro
  DAY_BG_NEGATIVE: "#ffebee", // rojo claro
  DARK: "#174045",
};

// Colores específicos de ComponentInformacionEnDetalle
export const INFORMACION_DETALLE_COLORS = {
  BACKGROUND_ROW_SELECTED: "#d3f1f7",
  BACKGROUND_TABLE_HEADER: GENERAL_COLORS.BACKGROUND_TABLE_HEADER,
  BACKGROUND_ROW_ALTERNATE: "#f1f8ff",
  BACKGROUND_ROW_HOVER: "#677f89",
  BACKGROUND_ROW_SAME_DATE: "#40d5f0ff",
  TEXT_LIGHT: GENERAL_COLORS.BACKGROUND_WHITE,
  TEXT_MUTED: "#999",
  TEXT_BRAND: GENERAL_COLORS.TEXT_BRAND,
  SHADOW_DARK: GENERAL_COLORS.SHADOW_DARK,
  LOADING_PROGRESS: "#39ff14",
  PALETTE_RED_LIGHT: "#ffebee",
  PALETTE_GREEN_LIGHT: "#e8f5e8",
  PALETTE_BLUE_LIGHT: "#d6bbe0ff",
  PALETTE_ORANGE_LIGHT: "#fff3e0",
  PALETTE_PURPLE_LIGHT: "#f3e5f5",
  PALETTE_TURQUOISE_LIGHT: "#e0f2e3ff",
  PALETTE_PINK_LIGHT: "#fce4ec",
  PALETTE_LIME_LIGHT: "#f1f8e9",
  PALETTE_INDIGO_LIGHT: "#e8eaf6",
  PALETTE_YELLOW_LIGHT: "#fff8e1",
};

// Colores específicos de ComponentSimplifiedCronometro
export const SIMPLIFIED_CRONOMETRO_COLORS = {
  TEXT_WHITE: GENERAL_COLORS.BACKGROUND_WHITE,
  TEXT_BLACK: "#000",
  TEXT_SECONDARY: "#555",
  BACKGROUND_HOVER: GENERAL_COLORS.BACKGROUND_NEUTRAL,
  BACKGROUND_LIGHT: "#E0E0E0",
  BACKGROUND_CARD: "#f9f9f9",
  BORDER_LIGHT: "#ddd",
  BORDER_MEDIUM: GENERAL_COLORS.BORDER_LIGHT,
};

// Colores específicos de CrimpingScreen
export const CRIMPING_SCREEN_COLORS = {
  BACKGROUND_TABLE_HEADER: "#dfdfdf",
  BORDER_MEDIUM: "#ccc",
};

// Colores específicos de FinalWeighingAdminSection
export const FINAL_WEIGHING_ADMIN_COLORS = {
  BACKGROUND_TABLE_HEADER: GENERAL_COLORS.BACKGROUND_TABLE_HEADER,
  BACKGROUND_HOVER: GENERAL_COLORS.BACKGROUND_ROW_HOVER,
  BACKGROUND_CARD: "#F9FAFB",
  BACKGROUND_INPUT: "#F3F4F6",
  BACKGROUND_ROW_ALTERNATE: "#F9FAFB",
  BACKGROUND_BUTTON_PRIMARY: "#174045",
  BACKGROUND_BUTTON_SECONDARY: "#1e4d52",
  TEXT_BRAND: GENERAL_COLORS.TEXT_BRAND,
  TEXT_MUTED: GENERAL_COLORS.TEXT_MUTED,
  TEXT_PRIMARY: "#374151",
  TEXT_SECONDARY: "#6B7280",
  BORDER_BRAND: GENERAL_COLORS.BORDER_BRAND,
  BORDER_LIGHT: "#e5e7eb",
  BORDER_CARD: "#e5e7eb",
  BORDER_TABLE: "#e5e7eb",
};

// Colores específicos de AdminOperationScreen
export const ADMIN_OPERATION_SCREEN_COLORS = {
  BACKGROUND_TABLE_HEADER: GENERAL_COLORS.BACKGROUND_TABLE_HEADER,
  BACKGROUND_DARK: "#354a53",
};

// Colores específicos de FindingsWeighingScreen
export const FINDINGS_WEIGHING_SCREEN_COLORS = {
  BACKGROUND_TABLE_HEADER: GENERAL_COLORS.BACKGROUND_TABLE_HEADER,
  BACKGROUND_HOVER: GENERAL_COLORS.BACKGROUND_ROW_HOVER,
  BACKGROUND_CARD: "#F9FAFB",
  BACKGROUND_INPUT: "#F3F4F6",
  BACKGROUND_ROW_ALTERNATE: "#F9FAFB",
  BACKGROUND_BUTTON_PRIMARY: "#174045",
  BACKGROUND_BUTTON_SECONDARY: "#1e4d52",
  TEXT_BRAND: GENERAL_COLORS.TEXT_BRAND,
  TEXT_SECONDARY: GENERAL_COLORS.TEXT_SECONDARY,
  TEXT_MUTED: GENERAL_COLORS.TEXT_MUTED,
  TEXT_ICON: "#ff6b6b",
  TEXT_PRIMARY: "#374151",
  BORDER_BRAND: GENERAL_COLORS.BORDER_BRAND,
  BORDER_LIGHT: "#e5e7eb",
  BORDER_CARD: "#e5e7eb",
  BORDER_TABLE: "#e5e7eb",
};

// Colores específicos de FoundryScreen
export const FOUNDRY_SCREEN_COLORS = {
  BACKGROUND_ROW_HOVER: "#c7d7e0",
  BACKGROUND_ROW_SELECTED: "#cceeff",
  BACKGROUND_ROW_EVEN: GENERAL_COLORS.BACKGROUND_WHITE,
  BACKGROUND_ROW_ODD: "#f9f9f9",
  BACKGROUND_TABLE_HEADER: GENERAL_COLORS.BACKGROUND_TABLE_HEADER,
  BACKGROUND_BUTTON_SUCCESS: "#4caf50",
  BACKGROUND_BUTTON_SUCCESS_HOVER: "#45a049",
  TEXT_BRAND: GENERAL_COLORS.TEXT_BRAND,
  TEXT_MUTED: GENERAL_COLORS.TEXT_MUTED,
  BORDER_BRAND: GENERAL_COLORS.BORDER_BRAND,
};

// Colores específicos de LoginScreen
export const LOGIN_SCREEN_COLORS = {
  BACKGROUND_DARK: "#111",
  BACKGROUND_LIGHT: "#f6f6f6",
  BACKGROUND_BUTTON_PRIMARY: "#37494f",
  BACKGROUND_BUTTON_SECONDARY: "#666666",
  TEXT_PRIMARY: "#333333",
  TEXT_WHITE: "#ffffff",
  TEXT_PLACEHOLDER: "#999999",
  BORDER_LIGHT: "#dddddd",
  ACTIVITY_INDICATOR: "#37494f",
};

// Colores específicos de IntermediateWeighing
export const INTERMEDIATE_WEIGHING_COLORS = {
  BACKGROUND_TABLE_HEADER: GENERAL_COLORS.BACKGROUND_TABLE_HEADER,
  BACKGROUND_HOVER: GENERAL_COLORS.BACKGROUND_ROW_HOVER,
  BACKGROUND_ERROR: "#f8d7da",
  BACKGROUND_CARD: "#F9FAFB",
  BACKGROUND_INPUT: "#F3F4F6",
  BACKGROUND_ROW_ALTERNATE: "#F9FAFB",
  BACKGROUND_BUTTON_PRIMARY: "#174045",
  BACKGROUND_BUTTON_SECONDARY: "#1e4d52",
  TEXT_BRAND: GENERAL_COLORS.TEXT_BRAND,
  TEXT_MUTED: GENERAL_COLORS.TEXT_MUTED,
  TEXT_ERROR: "#721c24",
  TEXT_PRIMARY: "#374151",
  TEXT_SECONDARY: "#6B7280",
  BORDER_BRAND: GENERAL_COLORS.BORDER_BRAND,
  BORDER_ERROR: "#f5c6cb",
  BORDER_LIGHT: "#e5e7eb",
  BORDER_CARD: "#e5e7eb",
  BORDER_TABLE: "#e5e7eb",
};

// Colores específicos de MachiningScreen
export const MACHINING_SCREEN_COLORS = {
  BACKGROUND_TABLE_HEADER: GENERAL_COLORS.BACKGROUND_TABLE_HEADER,
  BACKGROUND_ROW: "#f8f9fa",
  BACKGROUND_ROW_ALTERNATE: GENERAL_COLORS.BACKGROUND_ROW_ALTERNATE,
  BACKGROUND_LOADING: "#f0f4f4",
  BACKGROUND_ERROR: "#fef2f2",
  BACKGROUND_BUTTON_PRIMARY: "#174045",
  BACKGROUND_BUTTON_SECONDARY: "#1e4d52",
  BACKGROUND_BUTTON_NEUTRAL: "#d1d5db",
  BACKGROUND_BUTTON_DISABLED: "#f9fafb",
  BACKGROUND_CARD: "#F9FAFB",
  BACKGROUND_INPUT: "#F3F4F6",
  TEXT_PRIMARY: GENERAL_COLORS.TEXT_PRIMARY,
  TEXT_BRAND: GENERAL_COLORS.TEXT_BRAND,
  TEXT_BRAND_DARK: "#314f5b",
  TEXT_SECONDARY: "#6b7280",
  TEXT_MUTED: GENERAL_COLORS.TEXT_MUTED,
  TEXT_ERROR: "#dc2626",
  TEXT_DARK: "#253e47",
  BORDER_LIGHT: "#e5e7eb",
  BORDER_MEDIUM: GENERAL_COLORS.BORDER_TABLE,
  BORDER_SECONDARY: "#f5f5f5",
  BORDER_INPUT: "#e5e7eb",
  BORDER_BRAND: GENERAL_COLORS.BORDER_BRAND,
  BORDER_BRAND_DARK: "#314f5b",
  BORDER_NEUTRAL: "#d1d5db",
  BORDER_CARD: "#e5e7eb",
  BORDER_TABLE: "#e5e7eb",
};

// Colores específicos de InfoScreen
export const INFO_SCREEN_COLORS = {
  BACKGROUND_TABLE_HEADER: "#f0f0f0",
  BACKGROUND_BUTTON_PRIMARY: "#4d5f68",
  BACKGROUND_BUTTON_SECONDARY: "#efefef",
};

// Colores específicos de OverallStatusScreen
export const OVERALL_STATUS_SCREEN_COLORS = {
  BACKGROUND_NEUTRAL: GENERAL_COLORS.BACKGROUND_NEUTRAL,
  BACKGROUND_ERROR: "#d98880",
  BACKGROUND_SUCCESS: "#9fd980",
  BACKGROUND_HOVER: "#c7d7e0",
  BACKGROUND_CARD: GENERAL_COLORS.BACKGROUND_CARD,
  BACKGROUND_INPUT: "#f1f5f9",
  BACKGROUND_BUTTON_PRIMARY: GENERAL_COLORS.BACKGROUND_BUTTON_PRIMARY,
  BACKGROUND_BUTTON_SECONDARY: GENERAL_COLORS.BACKGROUND_BUTTON_SECONDARY,
  BACKGROUND_TABLE_HEADER: GENERAL_COLORS.BACKGROUND_TABLE_HEADER,
  BACKGROUND_WHITE: GENERAL_COLORS.BACKGROUND_WHITE,
  TEXT_CARD: "#475569",
  TEXT_BRAND: GENERAL_COLORS.TEXT_BRAND,
  TEXT_MUTED: "#94a3b8",
  TEXT_WHITE: GENERAL_COLORS.BACKGROUND_WHITE,
  BORDER_CARD: "#e2e8f0",
  BORDER_BRAND: GENERAL_COLORS.BORDER_BRAND,
  BORDER_TABLE: GENERAL_COLORS.BORDER_TABLE,
};

// Colores específicos de PartsMovements
export const PARTS_MOVEMENTS_COLORS = {
  BACKGROUND_CARD: GENERAL_COLORS.BACKGROUND_CARD,
  BACKGROUND_INPUT: "#f1f5f9",
  BACKGROUND_BUTTON_PRIMARY: GENERAL_COLORS.BACKGROUND_BUTTON_PRIMARY,
  BACKGROUND_BUTTON_SECONDARY: GENERAL_COLORS.BACKGROUND_BUTTON_SECONDARY,
  BACKGROUND_TABLE_HEADER: GENERAL_COLORS.BACKGROUND_TABLE_HEADER,
  BACKGROUND_ROW_ALTERNATE: GENERAL_COLORS.BACKGROUND_ROW_ALTERNATE,
  BACKGROUND_ROW_HOVER: "#e2e8f0",
  BACKGROUND_WHITE: "#fafafa",
  TEXT_CARD: "#475569",
  TEXT_BRAND: GENERAL_COLORS.TEXT_BRAND,
  TEXT_MUTED: "#94a3b8",
  TEXT_DARK: "#374151",
  TEXT_LINK: "#1e40af",
  TEXT_PRIMARY: GENERAL_COLORS.TEXT_PRIMARY,
  TEXT_SECONDARY: GENERAL_COLORS.TEXT_SECONDARY,
  BORDER_CARD: "#e2e8f0",
  BORDER_BRAND: GENERAL_COLORS.BORDER_BRAND,
  BORDER_TABLE: GENERAL_COLORS.BORDER_TABLE,
  BORDER_LIGHT: "#f0f0f0",
  BORDER_NEUTRAL: "#e5e7eb",
  BORDER_BRAND_DARK: "#314f5b",
};

// Colores específicos de UserDocumentScreen
export const USER_DOCUMENT_SCREEN_COLORS = {
  BACKGROUND_TABLE_HEADER: GENERAL_COLORS.BACKGROUND_TABLE_HEADER,
  BACKGROUND_ROW_ALTERNATE: "#F9FAFB",
  BACKGROUND_ROW_EVEN: GENERAL_COLORS.BACKGROUND_WHITE,
  BACKGROUND_ROW_ODD: "#f8f9fa",
  BACKGROUND_FOOTER: "#F9FAFB",
  BACKGROUND_CARD: "#F9FAFB",
  BACKGROUND_INPUT: "#F3F4F6",
  BACKGROUND_BUTTON_PRIMARY: "#174045",
  BACKGROUND_BUTTON_SECONDARY: "#1e4d52",
  TEXT_BRAND: GENERAL_COLORS.TEXT_BRAND,
  TEXT_MUTED: GENERAL_COLORS.TEXT_MUTED,
  TEXT_PRIMARY: "#374151",
  TEXT_SECONDARY: "#6B7280",
  TEXT_TERTIARY: "#455a64",
  BORDER_BRAND: GENERAL_COLORS.BORDER_BRAND,
  BORDER_TABLE: GENERAL_COLORS.BORDER_TABLE,
  BORDER_WHITE: GENERAL_COLORS.BACKGROUND_WHITE,
  BORDER_LIGHT: "#e5e7eb",
  BORDER_CARD: "#e5e7eb",
};

// Colores específicos de StoneControl
export const STONE_CONTROL_COLORS = {
  BACKGROUND_TABLE_HEADER: GENERAL_COLORS.BACKGROUND_TABLE_HEADER,
  BACKGROUND_BUTTON_PRIMARY: "#174045",
  BACKGROUND_BUTTON_SECONDARY: "#1e4d52",
  BACKGROUND_BUTTON_DISABLED: "#cccccc",
  BACKGROUND_CARD: "#F9FAFB",
  BACKGROUND_INPUT: "#F3F4F6",
  BACKGROUND_ROW_ALTERNATE: "#F9FAFB",
  TEXT_BRAND: GENERAL_COLORS.TEXT_BRAND,
  TEXT_MUTED: GENERAL_COLORS.TEXT_MUTED,
  TEXT_PRIMARY: "#374151",
  TEXT_SECONDARY: "#6B7280",
  BORDER_BRAND: GENERAL_COLORS.BORDER_BRAND,
  BORDER_LIGHT: "#e5e7eb",
  BORDER_CARD: "#e5e7eb",
  BORDER_TABLE: "#e5e7eb",
};

// Colores específicos de WeighingAdminSection
export const WEIGHING_ADMIN_SECTION_COLORS = {
  BACKGROUND_TABLE_HEADER: GENERAL_COLORS.BACKGROUND_TABLE_HEADER,
  BACKGROUND_HOVER: GENERAL_COLORS.BACKGROUND_ROW_HOVER,
  TEXT_BRAND: GENERAL_COLORS.TEXT_BRAND,
  TEXT_MUTED: GENERAL_COLORS.TEXT_MUTED,
  BORDER_BRAND: GENERAL_COLORS.BORDER_BRAND,
};

// Colores específicos de TimeAndStatusScreen
export const TIME_AND_STATUS_SCREEN_COLORS = {
  ICON_WEIGHT: "#cbcbcb",
  ICON_TIME_WORK: "#00e0ff",
  ICON_PROBLEM_QUALITY: "#ff5b5b",
  ICON_CRIMPING: "#fed872",
  ICON_DEFAULT: "#39cf05",
  STATUS_ERROR: "#a05151",
  STATUS_SUCCESS: "#b2d8b2",
  STATUS_ACTIVE: "#39cf05",
  STATUS_ACTIVE_HOVER: "#2e9e04",
  BACKGROUND_TABLE_HEADER: GENERAL_COLORS.BACKGROUND_TABLE_HEADER,
  BACKGROUND_BUTTON_PRIMARY: "#174045",
  BACKGROUND_WHITE: GENERAL_COLORS.BACKGROUND_WHITE,
};

// Colores específicos de TimeWorkScreen
export const TIME_WORK_SCREEN_COLORS = {
  STATUS_ERROR: "#a05151",
  BACKGROUND_TABLE_HEADER: GENERAL_COLORS.BACKGROUND_TABLE_HEADER,
};

// Colores específicos de validarDatosCalidad
export const VALIDAR_DATOS_CALIDAD_COLORS = {
  TEXT_BRAND: GENERAL_COLORS.TEXT_BRAND,
  TEXT_MUTED: GENERAL_COLORS.TEXT_MUTED,
  TEXT_PRIMARY: "#374151",
  TEXT_SECONDARY: "#6B7280",
  BORDER_BRAND: GENERAL_COLORS.BORDER_BRAND,
  BORDER_LIGHT: "#e5e7eb",
  BORDER_CARD: "#e5e7eb",
  BORDER_TABLE: "#e5e7eb",
  BACKGROUND_TABLE_HEADER: GENERAL_COLORS.BACKGROUND_TABLE_HEADER,
  BACKGROUND_HOVER: GENERAL_COLORS.BACKGROUND_ROW_HOVER,
  BACKGROUND_CARD: "#F9FAFB",
  BACKGROUND_INPUT: "#F3F4F6",
  BACKGROUND_ROW_ALTERNATE: "#F9FAFB",
  BACKGROUND_BUTTON_PRIMARY: "#174045",
  BACKGROUND_BUTTON_SECONDARY: "#1e4d52",
};

// Colores específicos de MultipleMOWork
export const MULTIPLE_MO_WORK_COLORS = {
  BACKGROUND_TABLE_HEADER: GENERAL_COLORS.BACKGROUND_TABLE_HEADER,
};

// Colores específicos de CompletedFoundries
export const COMPLETED_FOUNDRIES_COLORS = {
  BACKGROUND_TABLE_HEADER: GENERAL_COLORS.BACKGROUND_TABLE_HEADER,
  BACKGROUND_WHITE: "#fff",
  BACKGROUND_CARD: "#F9FAFB",
  BACKGROUND_INPUT: "#F3F4F6",
  BACKGROUND_ROW_ALTERNATE: "#F9FAFB",
  BACKGROUND_BUTTON_PRIMARY: "#174045",
  BACKGROUND_BUTTON_SECONDARY: "#1e4d52",
  TEXT_PRIMARY: "#374151",
  TEXT_SECONDARY: "#6B7280",
  TEXT_MUTED: GENERAL_COLORS.TEXT_MUTED,
  TEXT_BRAND: GENERAL_COLORS.TEXT_BRAND,
  BORDER_LIGHT: "#e5e7eb",
  BORDER_CARD: "#e5e7eb",
  BORDER_TABLE: "#e5e7eb",
  BORDER_BRAND: GENERAL_COLORS.BORDER_BRAND,
};

// Colores específicos de ProblemQualityScreen
export const PROBLEM_QUALITY_SCREEN_COLORS = {
  BORDER_LIGHT: GENERAL_COLORS.BORDER_LIGHT,
  BACKGROUND_BUTTON_PRIMARY: "#174045",
};

// Colores específicos de AdminControllerOptions
export const ADMIN_CONTROLLER_OPTIONS_COLORS = {
  BACKGROUND_TABLE_HEADER: GENERAL_COLORS.BACKGROUND_TABLE_HEADER,
};

// Colores específicos de FornitureDeliveryScreen
export const FORNITURE_DELIVERY_SCREEN_COLORS = {
  BACKGROUND_TABLE_CONTAINER: "#537575",
  BACKGROUND_TABLE_HEADER: "#174045",
};

// Colores específicos de InitialWeighing
export const INITIAL_WEIGHING_COLORS = {
  BACKGROUND_BUTTON: "#2a373c",
  PLACEHOLDER_TEXT: "#A0A0A0",
  LOADING_INDICATOR: "#39ff14",
};

// Colores específicos de StoneDeliveryScreen
export const STONE_DELIVERY_SCREEN_COLORS = {
  BACKGROUND_TABLE_CONTAINER: "#537575",
  BACKGROUND_TABLE_HEADER: "#174045",
  BORDER_LIGHT: GENERAL_COLORS.BORDER_LIGHT,
};

// Colores específicos de ScanScreen
export const SCAN_SCREEN_COLORS = {
  BACKGROUND_HOVER: "#557880",
};

// Colores específicos de OperarioScreen
export const OPERARIO_SCREEN_COLORS = {
  BACKGROUND_TABLE_HEADER: GENERAL_COLORS.BACKGROUND_TABLE_HEADER,
  BACKGROUND_NEUTRAL: GENERAL_COLORS.BACKGROUND_NEUTRAL,
  BACKGROUND_HOVER: GENERAL_COLORS.BACKGROUND_ROW_HOVER,
};

// Colores específicos de ComponentMiniResumenTabla
export const MINI_RESUMEN_TABLA_COLORS = {
  // Colores de fondo
  BACKGROUND_MAIN: "#f8f9fa",
  BACKGROUND_PIEZAS_EXPANDED: "#f0f8f0",
  BACKGROUND_FORNITURAS_EXPANDED: "#f8f0f8",
  BACKGROUND_ALEACIONES_EXPANDED: "#f0f8ff",
  BACKGROUND_HEADER: "#465d64",
  BACKGROUND_PENDIENTES: "#dee3e5",
  BACKGROUND_TERMINADAS: "#c1d1d8",
  BACKGROUND_TOTALES: "#9bb1bb",
  BACKGROUND_WHITE: "#ffffff",
  BACKGROUND_TOTAL_ROW: "#ffffff",
  BACKGROUND_DARK: "#174045",
  
  // Colores de texto
  TEXT_WHITE: "white",
  TEXT_BLACK: "#000000",
  TEXT_HEADER: "#263238",
  TEXT_SUCCESS: "#2E7D32",
  TEXT_SUBHEADER: "#455a64",
  TEXT_MUTED: "#999",
  TEXT_LOADING: "#999",
  
  // Colores de bordes
  BORDER_MAIN: "#b0bec5",
  BORDER_TOTAL: "#000000",
  BORDER_LIGHT: "#e0e0e0",
  
  // Colores específicos
  COLOR_BLUE: "#3888d8",
  COLOR_PURPLE: "#9c27b0",
  COLOR_GREEN_SUCCESS: "#2E7D32",
  COLOR_LOADING_SPINNER: "#546e7a",
};

// Colores específicos de ComponentConsultaPiezasTabla
export const CONSULTA_PIEZAS_TABLA_COLORS = {
  BACKGROUND_HEADER: "#658186",
  TEXT_HEADER: "#455a64",
  TEXT_PRIMARY: "#263238",
  TEXT_MUTED: "#546e7a",
  BORDER_LIGHT: "#b0bec5",
  BACKGROUND_DARK: "#174045",
};